import { render, staticRenderFns } from "./RegionForm.vue?vue&type=template&id=db22e0e8"
import script from "./RegionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports